module.exports = __webpack_public_path__ + "img/vk.6e496d3b.svg";